import thdCustomer from '@thd-olt-global/thd-customer';
import { PATH } from '../constants/routes';

/**
 * Takes in the name of the cookie and returns null if the key value pair
 * does not exist or the value of the cookie if it does exist.
 */
export const getCookie = (name: string) => {
  const prefix = `${name}=`;
  let begin = document.cookie.indexOf(`; ${prefix}`);

  let value = null;
  // cookie key/value pair is not the 2nd or further on.
  if (begin === -1) {
    begin = document.cookie.indexOf(prefix);
    if (begin !== 0) {
      return value;
    }
    const end = document.cookie.indexOf(';', begin);
    value = decodeURI(document.cookie.substring(begin + prefix.length, end));
  }
  // the cookie key/value pair does exist.
  begin += 2;
  let end = document.cookie.indexOf(';', begin);

  // the end of the cookie does not exist?
  if (end === -1) {
    end = document.cookie.length;
  }
  value = decodeURI(document.cookie.substring(begin + prefix.length, end));

  return value;
};

export const getAuthorizationToken = () =>
  window.encodeURIComponent(thdCustomer.token);

export const getIsUserLoggedIn = () => thdCustomer.isLoggedIn;

export const getIsUserPersisted = () => thdCustomer.isPersisted;

export const getUserEmail = () => thdCustomer.email;

export const getOnlineOrderPath = () =>
  thdCustomer.isLoggedIn ? PATH.ORDER_HISTORY : PATH.ONLINE_ORDER;

export const getRedirectToTrackingPath = () =>
  thdCustomer.isLoggedIn ? PATH.ORDER_HISTORY : PATH.ORDER_TRACKING;

export const getHostName = () =>
  process.env.NODE_ENV === 'development'
    ? 'homedepot.com'
    : window.location.hostname;

export const getMemberIdRatingsReviews = () => {
  const { svocID } = thdCustomer;
  return thdCustomer.token && svocID ? svocID : thdCustomer.userID;
};

export const getTmxId = () =>
  window.THD_ACCOUNT_LIB &&
  window.THD_ACCOUNT_LIB.TMX &&
  window.THD_ACCOUNT_LIB.TMX.getTMXsessionId();
